import React from 'react';

import { capitalizeFirstLetter } from '@utils/Util';

const TabItem = ({ tabName, activeTab, count, onClick }) => {
	const isActive = activeTab === tabName;
	const tabClass = isActive ? 'single-stepper active' : 'single-stepper';

	const mapBadgeClassName = (tabName) => {
		if (tabName === 'order_dashboard') return 'dashboard';
		if (tabName === 'completed') return 'complete';
		if (tabName === 'on_shipment') return 'shipment';
		if (tabName === 'approval') return 'cancel';
		return tabName;
	};

	return (
		<li>
			<div className={tabClass} onClick={() => onClick(tabName)}>
				<span className="task-name regular-14 p-0">
					{capitalizeFirstLetter(tabName.replace('_', ' '))}
					<span className={`order-count ${mapBadgeClassName(tabName.toLowerCase())}`}>{count}</span>
				</span>
			</div>
		</li>
	);
};

const MyOrderTabs = ({
	runningCount,
	shipmentCount,
	pendingCount,
	completedCount,
	cancelCount,
	activeTab,
	changeTab
}) => {
	const tabs = [
		{ name: 'ORDER_DASHBOARD', count: runningCount + shipmentCount },
		{ name: 'PENDING', count: pendingCount },
		{ name: 'RUNNING', count: runningCount },
		{ name: 'ON_SHIPMENT', count: shipmentCount },
		{ name: 'COMPLETED', count: completedCount },
		{ name: 'APPROVAL', count: cancelCount }
	];

	return (
		<ul className="order-tabs d-flex pt-2">
			{tabs.map((tab) => (
				<TabItem
					key={tab.name}
					tabName={tab.name}
					activeTab={activeTab}
					count={tab.count}
					onClick={changeTab}
				/>
			))}
		</ul>
	);
};

export default MyOrderTabs;
